module.exports = __webpack_public_path__ + "img/logo_bisniscom.0e2cc6b3.png";